module.exports = import("https://cdn.sheetjs.com/xlsx-0.20.2/package/xlsx.mjs");;